export default function blankLabel() {
  const processLinks = (links) => {
    links.forEach((link) => {
      // すでに aria-label が付いている場合は何もしない
      if (!link.hasAttribute('aria-label')) {
        // リンクが外部サイトか内部サイトかを判別
        const isExternal = !link.href.includes(location.origin);
        const label = isExternal
          ? '外部サイトを開く（新しいタブで開きます）'
          : 'このサイト内の別ページを開く（新しいタブで開きます）';
        link.setAttribute('aria-label', label);
      }

      // rel="noopener noreferrer" を追加
      if (!link.hasAttribute('rel')) {
        link.setAttribute('rel', 'noopener noreferrer');
      } else if (!link.getAttribute('rel').includes('noopener')) {
        // 必要に応じて rel 属性を拡張する
        link.setAttribute('rel', `${link.getAttribute('rel')} noopener noreferrer`);
      }
    });
  };

  // 初期表示時のリンクを処理
  const initialLinks = document.querySelectorAll('a[target="_blank"]');
  processLinks(initialLinks);

  // MutationObserver を使って動的に追加されるリンクも処理
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          // 新規のノードがリンクそのものの場合
          if (
            node.nodeType === 1 && // Elementノードか確認
            node.matches?.('a[target="_blank"]')
          ) {
            processLinks([node]);
          } else if (node.nodeType === 1) {
            // 子孫要素にターゲットとなるリンクがある場合
            const newLinks = node.querySelectorAll?.('a[target="_blank"]');
            if (newLinks.length > 0) {
              processLinks(newLinks);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true, // 直接の子要素の追加や削除を監視
    subtree: true, // 子孫要素も監視対象とする
  });
}
